import { OrderDetailsApiAdapter, OrderDetailsFilters } from '../adapters/OrderDetailsApiAdapter';
import { OrderDetails } from '../models/OrderDetails';

export interface OrderDetailsPage {
    orders: OrderDetails[];
    total: number;
    currentPage: number;
    lastPage: number;
    hasNextPage: boolean;
    nextPage?: number;
}

export class OrderDetailsService {
    constructor(private apiAdapter: OrderDetailsApiAdapter) { }

    async getOrdersByIds(orderIds: number[]): Promise<OrderDetails[]> {
        try {
            const response = await this.apiAdapter.getOrdersByIds(orderIds);
            return response.data;
        } catch (error) {
            console.error('Error fetching order details:', error);
            throw error;
        }
    }

    async getOrdersByIdsPaginated(filters: OrderDetailsFilters): Promise<OrderDetailsPage> {
        try {
            const response = await this.apiAdapter.getOrdersByIdsPaginated(filters);

            return {
                orders: response.data,
                total: response.meta.total,
                currentPage: response.meta.currentPage,
                lastPage: response.meta.lastPage,
                hasNextPage: response.meta.currentPage < response.meta.lastPage,
                nextPage: response.meta.currentPage < response.meta.lastPage
                    ? response.meta.currentPage + 1
                    : undefined
            };
        } catch (error) {
            console.error('Error fetching paginated order details:', error);
            throw error;
        }
    }
} 